import { IObject } from '../../../type_definitions/datatypes';

export abstract class BrowselistsPrecondition {
  abstract execute(queryFilters: IObject): any;
}